const BackgroundSize = {
  COVER: 'cover',
  CONTAIN: 'contain',
}

const BackgroundPosition = {
  CENTER: 'center',
}

/**
 *
 * @param {Source image width} sWidth
 * @param {Source image height} sHeight
 * @param {Destination width} dWidth
 * @param {Destination height} dHeight
 * @param {Size: cover or contain} size
 */
export function calculateSize(sWidth, sHeight, dWidth, dHeight, size) {
  const res = { width: 0, height: 0 }
  const xRatio = sWidth / dWidth
  const yRatio = sHeight / dHeight

  switch (size) {
    case BackgroundSize.COVER:
      {
        const ratio = Math.min(xRatio, yRatio)
        res.width = sWidth / ratio
        res.height = sHeight / ratio
      }
      break
    case BackgroundSize.CONTAIN:
      {
        const ratio = Math.max(xRatio, yRatio, 1)
        res.width = sWidth / ratio
        res.height = sHeight / ratio
      }
      break
    default:
      res.width = sWidth
      res.height = sHeight
      break
  }

  return res
}

export function calculatePosition(sWidth, sHeight, dWidth, dHeight, position) {
  const res = { x: 0, y: 0 }

  switch (position) {
    case BackgroundPosition.CENTER:
      {
        const xDiff = dWidth - sWidth
        const yDiff = dHeight - sHeight
        res.x = xDiff / 2
        res.y = yDiff / 2
      }
      break
  }

  return res
}
